<template>
  <div class="content doctorInformation">
    <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">所属公司</div> 
              <el-select size="mini" class="ipt-sty "  v-model="searchData.tenantGuid" placeholder="请选择" filterable>
              <el-option
                v-for="item in tenantList"
                :key="item.sendTenantGuid"
                :label="item.sendTenantName"
                :value="item.sendTenantGuid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">医生姓名</div> 
            <el-input size="mini"  class="ipt-sty " v-model="searchData.doctorName" placeholder="请输入姓名" clearable></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div" >所在医院</div> 
            <el-input size="mini"  class="ipt-sty " v-model="searchData.medName" placeholder="请输入所在医院" clearable></el-input>
          </el-col>
          <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="confirmSearch"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
        </el-row> 
        <el-row :gutter="24" class="mt15" v-if="showMore">
          <el-col :span="6">
            <div class="search-area-div">医生职称</div>
            <el-input size="mini"  class="ipt-sty " v-model="searchData.technicalTitles" placeholder="请输入医生职称" clearable></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">业务指派人</div>
            <el-input size="mini"  class="ipt-sty " v-model="searchData.createUserName" placeholder="请输入业务指派人" clearable></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div" >指派人手机</div>
            <el-input size="mini"  class="ipt-sty " v-model="searchData.createUserMobile" placeholder="请输入指派人手机" clearable></el-input>
          </el-col>
          <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.bizStateList" placeholder="请选择" filterable multiple>
            <el-option v-for="item in bizStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        </el-row>
        <!-- <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="searchData.updateName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col> 
        
        </el-row>-->
    </div>
    <div
      class="back-color-fff content-main-box"
      :style="'height:' + contentMainHeight + 'px;'"
    >
    <div class="button-area p16">
        <el-button  v-if="getBtnPermissionsByName('添加医生')" icon="el-icon-plus" size="mini" type="info" @click="addPath">添加医生</el-button>
        <el-button  v-if="getBtnPermissionsByName('批量导入')" icon="el-icon-plus" size="mini" type="info" @click="batchImport">批量导入</el-button>
        
        <el-button v-if="getBtnPermissionsByName('批量启用')" size="mini" type="info" @click="batchChangeState('Y')">批量启用</el-button>
        <el-button v-if="getBtnPermissionsByName('批量停用')" size="mini" class="fr" @click="batchChangeState('S')">批量停用</el-button>

        <el-button  v-if="getBtnPermissionsByName('批量导出')" size="mini" class="fr"  @click="report" v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button>
        <el-button  v-if="getBtnPermissionsByName('批量删除')" size="mini" class="fr" @click="getDeleteData(1, '')">批量删除</el-button>
      </div>
      <el-table ref="multipleTable" :height="tableHeight" :data="tableData" border style="width: 100%" v-loading="tableLoading" row-key="guid"
        @selection-change="handleSelectionChange" >
        <el-table-column type="selection" width="40" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">

            {{ (searchData.pageIndex - 1) * searchData.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" width="150" label="医生姓名" header-align="center" align="left"></el-table-column>
        <el-table-column prop="mobileNo" width="150" label="手机号" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="sex" width="60" label="性别" header-align="center" align="left"></el-table-column>
        <el-table-column prop="medName" width="250" label="所在医院" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.medName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="medDeptName" width="250" label="所在科室" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.medDeptName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="technicalTitles" width="150" label="医生职称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.technicalTitles || '-' }}</template>
        </el-table-column>
        <!-- <el-table-column
          prop="updateName"
          label="更新人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.updateName || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="approveState"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="bizState"
          width="96"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              bizStateObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="venue" width="250" label="所属区域" header-align="center" align="left">
          <template slot-scope="scope">
            <span v-show="scope.row.province && scope.row.city">
              {{ scope.row.province | province }}{{ scope.row.city | city }}{{ scope.row.district | district(1) }}
            </span>
            <span v-show="scope.row.province && !scope.row.city && !scope.row.district">
              {{ scope.row.province | province }}{{ scope.row.city | city(1) }}{{ scope.row.district | district(1) }}
            </span>
            <span v-show="!scope.row.province && !scope.row.city && !scope.row.district">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="150" label="业务指派人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="contacts" width="150" label="指派人手机号" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.createUserMobile || '-' }}</template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <a class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click.stop="editPath(scope.row.guid,false)">编辑 | </a> 
            <!-- <a v-if="scope.row.approveState === 'A' " class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a> -->
            <!-- <a  v-if="getBtnPermissionsByName('审核')"  class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a>
            <a v-if="scope.row.approveState === 'R' ||scope.row.approveState === 'Y'" class="txt-color" @click="toReview(scope.row)">
              撤回重审 |
            </a> -->
            <a class="txt-color" v-if="getBtnPermissionsByName('删除')" @click.stop="getDeleteData(2, scope.row.guid)">删除｜</a>
            <a class="txt-color"  v-if="getBtnPermissionsByName('详情')"   @click.stop="editPath(scope.row.guid,true)">详情  </a> 
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange" @current-change="handleCurrentChange"   :page-sizes="[10,20,50,100,200]" :current-page="searchData.pageIndex"
      :page-size="searchData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="searchData.totalRows">
    </el-pagination>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
export default {
  mixins:[btnPermisson],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight:window.innerHeight - 200,
      isRefresh:false,
      tenantList:[],
      fullscreenLoading: false,
      timeRange: '',
      updateTime: [], // 更新时间
      approveTime: [], // 审核时间
      searchData: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        medName: '',
        name: '',
        technicalTitles: '',
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      },
      tableLoading: false,
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      technicalTitlesList: [],
      multipleSelection:[],
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      bizStateOp: [
       
        {
          value: "S",
          text: "停用",
        },
        {
          value: "Y",
          text: "启用",
        },
      ],
      bizStateObj: {
        S: '停用',
        Y: '启用',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        S: 'danger',
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
    };
  },
  activated() {
    if (this.isRefresh) {
      this.getList();
    } else {
      this.isRefresh = true;
    }
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 324;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created(){
    this.getTechnicalTitlesList();
    this.getTenantOperationRelList();
     //按钮权限
    this.getMenuList();
  },
  methods: {
    
    getTenantOperationRelList() {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` + '&tenantGuid=' + localStorage.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            // if (self.tenantList && self.tenantList.length > 0) {
            //   self.searchData.tenantGuid = self.tenantList[0].sendTenantGuid;
            // }
            this.getList(1);
         // }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    confirmSearch() {
      this.tableLoading = true;
      this.searchData.pageIndex = 1;
      // this.searchData.updateStartTime = this.updateTime[0]
      //   ? this.$moment(this.updateTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.updateEndTime = this.updateTime[1]
      //   ? this.$moment(this.updateTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      // this.searchData.approveStartTime = this.approveTime[0]
      //   ? this.$moment(this.approveTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.approveEndTime = this.approveTime[1]
      //   ? this.$moment(this.approveTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      if(!this.searchData.bizStateList.length){
        this.searchData.bizStateList=['Y','S']
      }
      this.api.postJson(`/${serverConfig.msPersonnelService}/doctor/data/get`, this.searchData).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData = res.data.data.records||[];
          this.searchData.totalPage = res.data.data.totalPages;
          this.searchData.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      if(!this.searchData.tenantGuid) return;
      if(!this.searchData.bizStateList.length){
        this.searchData.bizStateList=['Y','S']
      }
      if(self.multipleSelection && self.multipleSelection.length > 0){
        self.$refs.multipleTable.clearSelection();
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/doctor/data/get`, this.searchData).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records||[];
          self.searchData.totalPage = res.data.data.totalPages;
          self.searchData.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.searchData = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        medName: '',
        name: '',
        technicalTitles: '',
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      };
      this.getTenantOperationRelList();
    },
    getTechnicalTitlesList() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=YSZC_HYS`
      ).then((resp) => {
        console.log(resp.data);
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          let arr = [];
          data.forEach((item) => {
            arr.push({
              label: item.name,
              value: item.parameterValue,
            });
          });
          that.technicalTitlesList = arr;
        }
      });
    },
    addPath() {
      this.$router.push('/doctorDetail')
    },
    editPath(guid,disabled) {
      this.$router.push({
        path: 'doctorDetail',
        query: {
          guid,
          disabled
        }
      })
    },
    // 去审核
    toReview(item) {
      this.$router.push({
        path: `/doctorAudit`,
        query: {
          guid: item.guid,
          tenantGuid: this.searchData.tenantGuid,
          productGuid: this.$route.query.productGuid,

        },
      });
    },
    report() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.searchData));
      req.pageSize = -1;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/doctor/data/export`, req).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api.postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, { 'colNames': colNames, 'datas': datas, 'sheetName': sheetName, 'fileNam': fileNam })
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      // self.empty();
    },
    handleSizeChange(val) {
      let self = this;
      self.searchData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.searchData.pageIndex = val;
      this.getList();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    batchImport(guid) {
      this.$router.push({ path: '/importNewManagementList', query: { productGuid: this.$route.query.productGuid,type:'0002' } });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msPersonnelService}/doctor/del`, self.multipleSelection).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.multipleSelection = [];
              self.$message.success('删除成功');
              self.getList(1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    batchImport() {
      // this.$router.push({ path: '/importDoctor' });
      this.$router.push({
        path: "/importNewManagementList",
        query: { 
          productGuid: this.$route.query.productGuid,
          type:'0002',
          tenantGuid:this.searchData.tenantGuid
        },
      });
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，客户信息将不被服务人员看到，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，负责该客户的服务人员将可以看到此信息，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.api
            .put(
              `/${serverConfig.msPersonnelService}/doctor/update-biz-state?bizState=${flg}`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

.doctorInformation /deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.doctorInformation /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

.doctorInformation /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-form-item__label {
  text-align: right;
}

.doctorInformation /deep/ .el-select {
  width: 100%;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  width:72px;
  text-align:right
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  justify-content: flex-end;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
</style>
